import { z } from "zod/v4";
const NotIncludeCsvSeparatorSchema = z
    .string()
    .regex(/^[^・、,•/]*$/, "次の記号を含めないでください: ・、,•/")
    .brand();
export const NotIncludeCsvSeparator = {
    schema: NotIncludeCsvSeparatorSchema,
};
//# sourceMappingURL=not-include-csv-separator.js.map